import { render, staticRenderFns } from "./KCPCertResponse.vue?vue&type=template&id=2561e496&"
import script from "./KCPCertResponse.vue?vue&type=script&lang=js&"
export * from "./KCPCertResponse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports